import { render, staticRenderFns } from "./Trashbin.vue?vue&type=template&id=e99cdea8&scoped=true"
import script from "./Trashbin.vue?vue&type=script&lang=js"
export * from "./Trashbin.vue?vue&type=script&lang=js"
import style0 from "./Trashbin.vue?vue&type=style&index=0&id=e99cdea8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99cdea8",
  null
  
)

export default component.exports